// components/ProductSelector.jsx
import React from "react";
import ProductSkeleton from "./ProductSkeleton";

const ProductSelector = ({
  productos,
  categorias,
  grupos,
  productSearchTerm,
  setProductSearchTerm,
  activeTab,
  setActiveTab,
  isLoading,
  hoveredProductId,
  setHoveredProductId,
  selectedProductIds,
  setSelectedProductIds,
  quantities,
  setQuantities,
  handleDragStart,
  handleAdd,
}) => {
  // Renderiza un producto/servicio
  const renderProductItem = (item) => {
    const quantity = quantities[item.id] || 1;
    const isActive =
      hoveredProductId === item.id || selectedProductIds.includes(item.id);
    const containerStyle = isActive ? { backgroundColor: "#eaf6fb" } : {};

    return (
      <div
        key={item.id}
        className="sp-product-item"
        style={containerStyle}
        draggable="true"
        onDragStart={(e) => handleDragStart(e, item, "product")}
        onMouseEnter={() => setHoveredProductId(item.id)}
        onMouseLeave={() => setHoveredProductId(null)}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedProductIds((prev) =>
            prev.includes(item.id)
              ? prev.filter((id) => id !== item.id)
              : [...prev, item.id]
          );
        }}
      >
        <div className="sp-product-icon">
          <img
            src={item.imagen || "/img/gris.jpg"}
            alt={item.nombre}
            className="sp-product-img"
          />
        </div>
        <div className="sp-product-info">
          <div className="sp-product-title">{item.nombre}</div>
          <div className="sp-product-subtitle">
            {item.numeroDeParteProveedor || "N/A"}
          </div>
        </div>
        <div className="sp-quantity">
          <button
            className="sp-quantity-btn"
            style={{ visibility: isActive ? "visible" : "hidden" }}
            onClick={(e) => {
              e.stopPropagation();
              setQuantities((prev) => ({
                ...prev,
                [item.id]: Math.max(1, quantity - 1),
              }));
            }}
          >
            <i className="bi bi-dash"></i>
          </button>
          <span
            className="sp-quantity-number"
            style={{ visibility: isActive ? "visible" : "hidden" }}
          >
            {quantity}
          </span>
          <button
            className="sp-quantity-btn"
            style={{ visibility: isActive ? "visible" : "hidden" }}
            onClick={(e) => {
              e.stopPropagation();
              setQuantities((prev) => ({
                ...prev,
                [item.id]: quantity + 1,
              }));
            }}
          >
            <i className="bi bi-plus"></i>
          </button>
        </div>
      </div>
    );
  };

  // Renderiza una categoría
  const renderCategoryItem = (cat) => {
    const quantity = quantities[cat.id] || 1;
    const isActive =
      hoveredProductId === cat.id || selectedProductIds.includes(cat.id);
    const containerStyle = isActive ? { backgroundColor: "#eaf6fb" } : {};

    return (
      <div
        key={cat.id}
        className="sp-product-item"
        style={containerStyle}
        draggable="true"
        onDragStart={(e) => handleDragStart(e, cat, "category")}
        onMouseEnter={() => setHoveredProductId(cat.id)}
        onMouseLeave={() => setHoveredProductId(null)}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedProductIds((prev) =>
            prev.includes(cat.id)
              ? prev.filter((id) => id !== cat.id)
              : [...prev, cat.id]
          );
        }}
      >
        <div className="sp-product-icon">
          <img
            src={cat.imagenUrl || "/img/gris.jpg"}
            alt={cat.nombre}
            className="sp-product-img"
          />
        </div>
        <div className="sp-product-info">
          <div className="sp-product-title">{cat.nombre}</div>
          <div className="sp-product-subtitle">
            {cat.descripcion || "Sin descripción"}
          </div>
        </div>
        <div className="sp-quantity">
          <button
            className="sp-quantity-btn"
            style={{ visibility: isActive ? "visible" : "hidden" }}
            onClick={(e) => {
              e.stopPropagation();
              setQuantities((prev) => ({
                ...prev,
                [cat.id]: Math.max(1, quantity - 1),
              }));
            }}
          >
            <i className="bi bi-dash"></i>
          </button>
          <span
            className="sp-quantity-number"
            style={{ visibility: isActive ? "visible" : "hidden" }}
          >
            {quantity}
          </span>
          <button
            className="sp-quantity-btn"
            style={{ visibility: isActive ? "visible" : "hidden" }}
            onClick={(e) => {
              e.stopPropagation();
              setQuantities((prev) => ({
                ...prev,
                [cat.id]: quantity + 1,
              }));
            }}
          >
            <i className="bi bi-plus"></i>
          </button>
        </div>
      </div>
    );
  };

  // Renderiza un grupo
  const renderGroupItem = (grupo) => {
    const quantity = quantities[grupo.id] || 1;
    const isActive =
      hoveredProductId === grupo.id || selectedProductIds.includes(grupo.id);
    const containerStyle = isActive ? { backgroundColor: "#eaf6fb" } : {};

    return (
      <div
        key={grupo.id}
        className="sp-product-item"
        style={containerStyle}
        draggable="true"
        onDragStart={(e) => handleDragStart(e, grupo, "group")}
        onMouseEnter={() => setHoveredProductId(grupo.id)}
        onMouseLeave={() => setHoveredProductId(null)}
        onClick={(e) => {
          e.stopPropagation();
          setSelectedProductIds((prev) =>
            prev.includes(grupo.id)
              ? prev.filter((id) => id !== grupo.id)
              : [...prev, grupo.id]
          );
        }}
      >
        <div className="sp-product-icon">
          <img
            src={grupo.imagenUrl || "/img/gris.jpg"}
            alt={grupo.nombre}
            className="sp-product-img"
          />
        </div>
        <div className="sp-product-info">
          <div className="sp-product-title">{grupo.nombre}</div>
          <div className="sp-product-subtitle">
            {grupo.descripcion || "Sin descripción"}
          </div>
        </div>
        <div className="sp-quantity">
          <button
            className="sp-quantity-btn"
            style={{ visibility: isActive ? "visible" : "hidden" }}
            onClick={(e) => {
              e.stopPropagation();
              setQuantities((prev) => ({
                ...prev,
                [grupo.id]: Math.max(1, quantity - 1),
              }));
            }}
          >
            <i className="bi bi-dash"></i>
          </button>
          <span
            className="sp-quantity-number"
            style={{ visibility: isActive ? "visible" : "hidden" }}
          >
            {quantity}
          </span>
          <button
            className="sp-quantity-btn"
            style={{ visibility: isActive ? "visible" : "hidden" }}
            onClick={(e) => {
              e.stopPropagation();
              setQuantities((prev) => ({
                ...prev,
                [grupo.id]: quantity + 1,
              }));
            }}
          >
            <i className="bi bi-plus"></i>
          </button>
        </div>
      </div>
    );
  };

  // Filtrados según la pestaña (para mostrar el mensaje si no hay nada)
  const filteredAll = productos.filter((item) =>
    item.nombre.toLowerCase().includes(productSearchTerm.toLowerCase())
  );
  const filteredCats = categorias.filter((cat) =>
    cat.nombre.toLowerCase().includes(productSearchTerm.toLowerCase())
  );
  const filteredGroups = grupos.filter((grupo) =>
    grupo.nombre.toLowerCase().includes(productSearchTerm.toLowerCase())
  );
  const filteredServices = productos.filter(
    (item) =>
      item.tipo &&
      item.tipo.toLowerCase() === "servicio" &&
      item.nombre.toLowerCase().includes(productSearchTerm.toLowerCase())
  );

  return (
    <section
      className="select-products-container"
      style={{ pointerEvents: "auto", opacity: 1 }}
    >
      <h1 className="calculador-title">Seleccionar Artículos</h1>

      {/* Buscador */}
      <div className="sp-search">
        <i className="bi bi-search sp-search-icon"></i>
        <input
          type="text"
          className="sp-search-input"
          placeholder="Buscar"
          value={productSearchTerm}
          onChange={(e) => setProductSearchTerm(e.target.value)}
        />
      </div>

      {/* Tabs */}
      <div className="sp-tabs">
        <button
          className={`sp-tab ${activeTab === "todos" ? "active" : ""}`}
          onClick={() => setActiveTab("todos")}
        >
          Todos <span className="sp-tab-count">{filteredAll.length}</span>
        </button>
        <button
          className={`sp-tab ${activeTab === "categorias" ? "active" : ""}`}
          onClick={() => setActiveTab("categorias")}
        >
          Categorías <span className="sp-tab-count">{filteredCats.length}</span>
        </button>
        <button
          className={`sp-tab ${activeTab === "grupos" ? "active" : ""}`}
          onClick={() => setActiveTab("grupos")}
        >
          Grupos <span className="sp-tab-count">{filteredGroups.length}</span>
        </button>
        <button
          className={`sp-tab ${activeTab === "servicios" ? "active" : ""}`}
          onClick={() => setActiveTab("servicios")}
        >
          Servicios{" "}
          <span className="sp-tab-count">{filteredServices.length}</span>
        </button>
      </div>

      {/* Lista principal */}
      <div className="sp-product-list">
        {isLoading ? (
          <>
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
            <ProductSkeleton />
          </>
        ) : (
          <>
            {activeTab === "todos" && (
              <>
                {filteredAll.length === 0 ? (
                  <p style={{ margin: "10px 0", textAlign: "center" }}>
                    No hay productos aún
                  </p>
                ) : (
                  filteredAll.map((item) => renderProductItem(item))
                )}
              </>
            )}
            {activeTab === "categorias" && (
              <>
                {filteredCats.length === 0 ? (
                  <p style={{ margin: "10px 0", textAlign: "center" }}>
                    No hay categorías aún
                  </p>
                ) : (
                  filteredCats.map((cat) => renderCategoryItem(cat))
                )}
              </>
            )}
            {activeTab === "grupos" && (
              <>
                {filteredGroups.length === 0 ? (
                  <p style={{ margin: "10px 0", textAlign: "center" }}>
                    No hay grupos aún
                  </p>
                ) : (
                  filteredGroups.map((grupo) => renderGroupItem(grupo))
                )}
              </>
            )}
            {activeTab === "servicios" && (
              <>
                {filteredServices.length === 0 ? (
                  <p style={{ margin: "10px 0", textAlign: "center" }}>
                    No hay servicios aún
                  </p>
                ) : (
                  filteredServices.map((item) => renderProductItem(item, true))
                )}
              </>
            )}
          </>
        )}
      </div>

      {/* Sección Almacén */}
      <div className="sp-almacen-section">
        <label className="sp-almacen-label">Almacén</label>
        <div className="sp-almacen-buttons">
          <button className="sp-almacen-btn active">
            <span className="sp-almacen-icon-container">
              <i className="bi bi-house-door-fill sp-almacen-icon"></i>
            </span>
            Almacén A
          </button>
          <button className="sp-almacen-btn">
            <span className="sp-almacen-icon-container">
              <i className="bi bi-house-door-fill sp-almacen-icon"></i>
            </span>
            Almacén B
          </button>
          <button className="sp-almacen-btn">
            <span className="sp-almacen-icon-container">
              <i className="bi bi-house-door-fill sp-almacen-icon"></i>
            </span>
            Almacén C
          </button>
        </div>
      </div>

      {/* Botones de acción */}
      <div className="sp-actions">
        <button className="sp-cancel-btn">Cancelar</button>
        <button className="sp-add-btn" onClick={handleAdd}>
          Agregar
        </button>
      </div>
    </section>
  );
};

export default ProductSelector;
